import { Controller } from '@hotwired/stimulus';
import { application } from 'src';
import { find, findAll, isVisible, toggleEnableElement, disableElement, enableElement } from '@fretadao/f-js-dom';

application.register(
  'line-schedule-recalibrations',
  class extends Controller {
    connect() {
      const submit = find('input[type=submit]', this.element);

      if(this.#isRoundTrip()) disableElement(submit, { addClasses: ['disabled'] });

      this.#directionOptions().forEach((directionOption) => {
        if(!this.#isRoundTrip()) this.#toogleInputs(directionOption.value);

        directionOption.addEventListener('change', ({ target: changedOption }) => {
          if(this.#directionOptions().find((option) => option.checked)) enableElement(submit, { removeClasses: ['disabled'] });
          else disableElement(submit, { addClasses: ['disabled'] });

          this.#toogleInputs(changedOption.value);
        });
      });
    }

    #scheduleFields(direction) {
      return findAll(`.${direction}_waypoints input`, this.element).filter(isVisible);
    }

    #directionOptions() {
      return findAll('.update_directions input', this.element);
    }

    #isRoundTrip() {
      return this.#directionOptions().length > 1
    }

    #toogleInputs(direction) {
      this.#scheduleFields(direction).forEach((scheduleField) => {
        const waypointFields = findAll(`input[id^="${scheduleField.id.replace('schedule', '')}"]`);
        toggleEnableElement(waypointFields)
      });
    }
  }
)
